<!-- =========================================================================================
    File Name: VxSidebar.vue
    Description: Sidebar Component
    Component Name: VxSidebar
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="parentx">
    <vs-sidebar
      v-hammer:swipe.left="onSwipeLeft"
      ref="mainSidebar"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce || this.$route.collapseSidebar"
      default-index="-1"
      class="sidebarx main-menu-sidebar items-no-padding"
      v-model="isSidebarActive"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :reduce-not-hover-expand="true"
    >
      <div class="sidebar-content-wrapper">
        <div
          class="header-sidebar flex items-end justify-between"
          slot="header"
        >
          <div class="logo flex items-center">
            <img :src="logo" alt="logo" class="w-10 mr-4" v-if="logo" />
            <span
              class="logo-text"
              v-show="!reduce"
              v-if="title"
              >{{ title }}</span
            >
          </div>
          <div>
            <template v-if="showCloseButton">
              <feather-icon
                icon="XIcon"
                class="m-0 cursor-pointer"
                @click="$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false)"
              ></feather-icon>
            </template>
            <template v-else-if="!showCloseButton && !sidebarItemsMin">
              <feather-icon
                icon="DiscIcon"
                class="mr-0 cursor-pointer"
                svg-classes="stroke-current"
                v-show="!reduce"
                @click="toggleReduce(true)"
                id="btnSidebarToggler"
              ></feather-icon>
              <feather-icon
                icon="CircleIcon"
                class="mr-0 cursor-pointer"
                svg-classes="stroke-current"
                v-show="reduce"
                @click="toggleReduce(false)"
                id="btnSidebarToggler"
              ></feather-icon>
            </template>
          </div>
        </div>

        <div class="shadow-bottom" v-show="showShadowBottom"></div>

        <VuePerfectScrollbar
          ref="mainSidebarPs"
          class="scroll-area--main-sidebar pt-2"
          :class="{ 'with-bottom-toggle': reduce && !showCloseButton }"
          :settings="settings"
          @ps-scroll-y="psSectionScroll"
        >
          <template v-for="(sidebarItem, index) in sidebarItems">
            <!-- GROUP ITEM HEADER -->
            <span
              :key="`header-${index}`"
              v-if="
                shouldShowInCurrentFormFactor(sidebarItem) &&
                sidebarItem.header &&
                !sidebarItemsMin &&
                (!$store.state.IsGuestUser || ($store.state.IsGuestUser && sidebarItem.ShowForGuestUser))
              "
              class="navigation-header truncate"
              >{{ $t(sidebarItem.i18n) || sidebarItem.header }}</span
            >
            <template
              v-else-if="
                shouldShowInCurrentFormFactor(sidebarItem) &&
                !sidebarItem.header &&
                (!$store.state.IsGuestUser || ($store.state.IsGuestUser && sidebarItem.ShowForGuestUser))
              "
            >
              <!-- IF IT'S SINGLE ITEM -->
              <vx-sidebar-item
                ref="sidebarLink"
                :key="`sidebarItem-${index}`"
                v-if="!sidebarItem.submenu"
                :index="index"
                :to="sidebarItem.slug != 'external' ? sidebarItem.url : ''"
                :href="sidebarItem.slug == 'external' ? sidebarItem.url : ''"
                :icon="sidebarItem.icon"
                :target="sidebarItem.target"
                :isDisabled="sidebarItem.isDisabled"
                :IsVisualStudio="
                  sidebarItem.hideFormFactors &&
                  sidebarItem.hideFormFactors['VisualStudio']
                " 
                :slug="sidebarItem.slug" 
                :ShowForGuestUser="sidebarItem.ShowForGuestUser"
                :IsAbsolute="sidebarItem.IsAbsolute"
              >
                <span v-show="!sidebarItemsMin" class="truncate">{{
                  $t(sidebarItem.i18n) || sidebarItem.name
                }}</span>
                <vs-chip
                  class="ml-auto"
                  :color="sidebarItem.tagColor"
                  v-if="sidebarItem.tag && !reduce"
                  >{{ sidebarItem.tag }}</vs-chip
                >
              </vx-sidebar-item>

              <!-- IF HAVE SUBMENU / DROPDOWN -->
              <template v-else>
                <vx-sidebar-group
                  ref="sidebarGrp"
                  :key="`group-${index}`"
                  :openHover="openGroupHover"
                  :group="sidebarItem"
                  :groupIndex="index"
                  :open="isGroupActive(sidebarItem)"
                >
                </vx-sidebar-group>
              </template>
            </template>
          </template>
        </VuePerfectScrollbar>

        <!-- Bottom Toggle Button -->
        <div class="sidebar-bottom-toggle" v-if="reduce && !showCloseButton">
          <vs-button
            icon-pack="feather"
            :icon="sidebarItemsMin ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
            size="small"
            color="primary"
            type="flat"
            @click="toggleSidebarExpansion"
            class="w-full"
          >
            <span v-if="!sidebarItemsMin" class="ml-2">Collapse</span>
            <span v-else class="ml-2">Expand</span>
          </vs-button>
        </div>
      </div>
    </vs-sidebar>
    <div
      v-hammer:swipe.right="onSwipeRightSidebarSwipeArea"
      v-if="!isSidebarActive"
      class="sidebar-swipe-area"
      id="sidebar-swipe-area"
    ></div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VxSidebarGroup from "./VxSidebarGroup.vue";
  import VxSidebarItem from "./VxSidebarItem.vue";
  import accountsService from "../../../accounts/accountsService";
  

export default {
  name: "vx-sidebar",
  props: {
    sidebarItems: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
    },
    logo: {
      type: String,
    },
    parent: {
      type: String,
    },
    openGroupHover: {
      type: Boolean,
      default: false,
    },
    reduceNotRebound: {
      type: Boolean,
      default: true, // Disable bounce animation
    },
  },
  data: () => ({
    clickNotClose: false, // disable close sidebar on outside click
    reduce: false, // determines if sidebar is reduce - component property
    showCloseButton: false, // show close button in smaller devices
    settings: {
      // perfectscrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: 1,
      swipeEasing: true,
    },
    windowWidth: window.innerWidth, //width of windows
    showShadowBottom: false,
  }),
  computed: {
    isSidebarActive: {
      get() {
        return this.$store.state.isSidebarActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", val);
      },
    },
    reduceSidebar() {
      return Boolean(this.reduce && this.reduceButton);
    },
    reduceButton: {
      get() {
        return this.$store.state.reduceButton;
      },
      set(val) {
        this.$store.commit("TOGGLE_REDUCE_BUTTON", val);
      },
    },
    sidebarItemsMin() {
      return this.$store.state.sidebarItemsMin;
    },
    isGroupActive() {
      return (sidebarItem) => {
        const path = this.$route.fullPath;
        let open = false;
        let func = function (sidebarItem) {
          if (sidebarItem.submenu) {
            sidebarItem.submenu.forEach((item) => {
              if (path == item.url) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };
        func(sidebarItem);
        return open;
      };
    },
    isVisualStudio() {
      return this.$store.state.IsVisualStudio;
    },
  },
  watch: {
    reduce(val) {
      if (val == true) {
        this.$store.dispatch("updateSidebarWidth", "reduced");
      } else {
        this.$store.dispatch("updateSidebarWidth", "default");
      }

      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    },
    reduceButton() {
      this.setSidebarWidth();
    },
    $route(to) {
      if (this.isSidebarActive && this.showCloseButton)
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
      if (to.meta.collapseSidebar) {
        this.$store.dispatch("updateSidebarWidth", "reduced");
        this.$store.commit("UPDATE_SIDEBAR_ITEMS_MIN", false);
      } else {
        this.$store.dispatch("updateSidebarWidth", "default");
        this.$store.commit("UPDATE_SIDEBAR_ITEMS_MIN", false);
      }

      this.setSidebarWidth();
    },
  },
  methods: {
    toggleReduce(val) {
      this.reduceButton = val;
      this.setSidebarWidth();
    },
    toggleSidebarExpansion() {
      // Toggle sidebar expansion - control both width and text visibility
      this.reduceButton = !this.reduceButton;
      this.$store.commit("UPDATE_SIDEBAR_ITEMS_MIN", !this.reduceButton);
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.$route.meta.collapseSidebar) {
        this.reduce = true;
        this.$store.dispatch("updateSidebarWidth", "reduced");
        this.$store.commit("UPDATE_SIDEBAR_ITEMS_MIN", true);
        this.showCloseButton = false;
        this.clickNotClose = true;
      } else if (this.windowWidth < 1200) {
        if (this.windowWidth < 992)
          this.$store.commit("UPDATE_WINDOW_BREAKPOINT", "md");
        else this.$store.commit("UPDATE_WINDOW_BREAKPOINT", "lg");

        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
        if (this.reduceButton) this.reduce = false;
        // this.reduceButton = false;
        this.showCloseButton = true;
        this.clickNotClose = false;
        this.$store.dispatch("updateSidebarWidth", "no-sidebar");
        this.$store.commit("UPDATE_SIDEBAR_ITEMS_MIN", false);
      } else {
        this.$store.commit("UPDATE_WINDOW_BREAKPOINT", "xl");
        if (this.reduceButton) this.reduce = true;
        else this.reduce = false;

        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
        if (this.reduceButton && !this.isMouseEnter)
          this.$store.commit("UPDATE_SIDEBAR_ITEMS_MIN", true);
        else this.$store.commit("UPDATE_SIDEBAR_ITEMS_MIN", false);

        this.clickNotClose = true;
        this.showCloseButton = false;
        if (this.reduceSidebar)
          this.$store.dispatch("updateSidebarWidth", "reduced");
        else this.$store.dispatch("updateSidebarWidth", "default");
      }
    },
    psSectionScroll() {
      if (this.$refs.mainSidebarPs.$el.scrollTop > 0)
        this.showShadowBottom = true;
      else this.showShadowBottom = false;
    },
    onSwipeLeft() {
      if (this.isSidebarActive && this.showCloseButton)
        this.isSidebarActive = false;
    },
    onSwipeRightSidebarSwipeArea() {
      if (!this.isSidebarActive && this.showCloseButton)
        this.isSidebarActive = true;
    },
    shouldShowInCurrentFormFactor(item) {
      if (
        this.isVisualStudio &&
        item &&
        item.hideFormFactors &&
        item.hideFormFactors["IsVisualStudio"]
      ) {
        return false;
      }
      return true;
    },
    itemClick(item) {
      alert('Click');
    }
  },
  components: {
    VxSidebarGroup,
    VxSidebarItem,
    VuePerfectScrollbar,
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);
    });
    this.setSidebarWidth();
    var userInfo = accountsService.getUserFromLocalStorage();
    if (userInfo) {
      var userObject = JSON.parse(userInfo);
      this.$store.commit("CURRENT_USER", userObject.User);
      this.$store.commit("IS_GUEST_USER", userObject?.User?.isAnonymous);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/components/vxSidebar.scss";

.sidebar-content-wrapper {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.sidebar-bottom-toggle {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.95);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  z-index: 10;
  
  .vs-button {
    border-radius: 8px;
    font-weight: 500;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }
}

// Dark theme support
.theme-dark .sidebar-bottom-toggle {
  background: rgba(16, 22, 58, 0.95);
  border-top-color: rgba(255, 255, 255, 0.1);
}

// Adjust scroll area when bottom toggle is present
.scroll-area--main-sidebar.with-bottom-toggle {
  padding-bottom: 5rem; // Space for the bottom toggle button
}
</style>
